<template>
  <v-row class="px-4">
    <v-row class="px-2">
      <v-col cols="12" sm="12" md="12" class="text-center font-weight-bold">
        Статистика по приёму писем  от юридических лиц на период с
        <template>
          {{ startFilterDisplayValue }}
        </template>
        по
        <template>
          {{ endFilterDisplayValue }}
        </template>
        ( по филиалам )
      </v-col>
    </v-row>
    <v-row class="px-2">
    <v-col cols="12" sm="2" md="2" class="d-flex align-center justify-center justify-md-end d-print-none">
      <v-select v-model="filters.type"
                :items="typeOptions"
                label="Выбрать версию"

      />
    </v-col>
      <v-col cols="12" md="3" class="d-flex justify-center justify-md-end d-print-none">
        <v-menu
            v-model="filterStartMenu"
            transition="scale-transition"
            offset-y
            :nudge-right="40"
            max-width="290px"
            min-width="290px"
            :close-on-content-click="false"
        >
          <template v-slot:activator="{on}">
            <v-text-field
                label="Начало пероида"
                v-model="startFilterDisplayValue"
                readonly

                v-on="on"
                flat
            />
          </template>
          <v-date-picker
              v-model="filters.start"
              @change="onFilterStartChanged"
              no-title
              scrollable
              locale="ru"
              first-day-of-week="1"
              :allowed-dates="(date) => {
                if (this.allowedFullAccessToPeriod) {
                  return true
                }


                const currentDate = new Date();
                const lastMonth = new Date();
                lastMonth.setMonth(currentDate.getMonth() - -1);
                const secondToLastMonth = new Date();
                secondToLastMonth.setMonth(currentDate.getMonth() - 2);

                return date <= lastMonth.toISOString().substr(0, 7) &&
                date >= secondToLastMonth.toISOString().substr(0, 7)&&
                date <= new Date().toISOString().substr(0, 10);
              }"
          />
        </v-menu>
      </v-col>
      <v-col cols="12" md="3" class="d-flex justify-center justify-md-end d-print-none">
        <v-menu
            v-model="filterEndMenu"
            transition="scale-transition"
            offset-y
            :nudge-right="40"
            max-width="290px"
            min-width="290px"
            :close-on-content-click="false"
        >
          <template v-slot:activator="{on}">
            <v-text-field
                label="Конец пероида"
                v-model="endFilterDisplayValue"
                readonly

                v-on="on"
                flat
            />
          </template>
          <v-date-picker
              v-model="filters.end"
              @change="onFilterEndChanged"
              no-title
              scrollable
              locale="ru"
              first-day-of-week="1"
              :allowed-dates="(date) => {
                const currentDate = new Date();
                const lastMonth = new Date();
                lastMonth.setMonth(currentDate.getMonth() - -1);
                const secondToLastMonth = new Date();
                secondToLastMonth.setMonth(currentDate.getMonth() - 2);

                return date <= lastMonth.toISOString().substr(0, 7) &&
                date >= secondToLastMonth.toISOString().substr(0, 7) &&
                date <= new Date().toISOString().substr(0, 10);
              }"
          />
        </v-menu>
      </v-col>
      <v-col cols="12" md="12" class="d-flex align-center justify-center justify-md-end d-print-none">
        <v-btn :disabled="disableRefreshButton" @click="onRefreshClicked" color="primary me-2" large>Обновить</v-btn>
        <v-btn @click="onPrintClicked" color="primary" large>Распечатать</v-btn>
      </v-col>
      <v-col cols="12">
        <v-simple-table dense>
          <template v-slot:default>
            <table>
              <thead>
              <tr>
                <th rowspan="2" style="background-color: aliceblue" @click="toggleClients()" class="text-center filter-header">Организации</th>
                <th @click="toggleRegion(item.Region.Id)" :style="{ backgroundColor: filters.selectedRegions.includes(item.Region.Id) ? 'aliceblue' : '#e5e5e5' }" v-for="(item, index) in items && items.length > 0 && items[0].Regions ? items[0].Regions : []" class="filter-header" :key="index">
                  <div class="d-flex">
                    {{ item.Region.Name }}
<!--                    <router-link class="d-print-none" style="text-decoration: none; color: black" :to="{name: 'report-processing-clientincomming-by-area', params: {regionId: item.Region.Id, filters: filters}}">-->
<!--                      <v-icon>mdi-import</v-icon>-->
<!--                    </router-link>-->
                  </div>
                </th>
                <th rowspan="2" class="text-center filter-header" style="background-color: aliceblue">Общее</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in items" :key="index">
                <td style="height: 40px; padding: 5px" @click="toggleClient(item.Client.id)" :style="{ backgroundColor: filters.selectedClients.includes(item.Client.id) ? 'aliceblue' : '#e5e5e5' }" class="text-center filter-header">{{ item.Client.name }}</td>
                <td :style="{ backgroundColor: filters.selectedClients.includes(item.Client.id) && filters.selectedRegions.includes(region.Region.Id) ? '' : '#e5e5e5' }" v-for="(region, clientIndex) in item.Regions" class="text-center filter-header" :key="clientIndex">
                  {{ region.Count }}
                </td>
                <td :style="{ backgroundColor: totalsByClient(item.Client) !== null ? 'aliceblue' : '#e5e5e5' }" class="filter-header"> {{ totalsByClient(item.Client) }}</td>
              </tr>
              <tr>
                <td class="text-center filter-header" style="background-color: aliceblue">Общее</td>
                <td :style="{ backgroundColor: filters.selectedRegions.includes(Number(clientIndex)) ? 'aliceblue' : '#e5e5e5' }" v-for="(region, clientIndex) in totalsByRegion.totalRegionCounts" :key="clientIndex">
                  {{ filters.selectedRegions.includes(Number(clientIndex)) ? region : null }}
                </td>
                <td style="background-color: aliceblue">{{ totals }}</td>
              </tr>
              </tbody>
            </table>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-snackbar
        v-if="disableRefreshButton"
        :timeout="-1"
        :value="true"
        absolute
        bottom
        color="red"
        right
    >
      Дату можно выбрать в пределах одного месяца
    </v-snackbar>
  </v-row>
</template>

<script>
import Moment from 'moment'
import _ from "underscore";
import {required} from 'vuelidate/lib/validators'
import {DateLimitForFilters} from "@/settings/server";

export default {
  name: "ProcessingClientIncomingReport",
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      filters: {
        start: null,
        end: null,
        date: null,
        type: 1,
        selectedRegions: [],
        selectedClients: [],
      },
      typeOptions: [
        { text: '1', value: 1 }
      ],
      startFilterDisplayValue: null,
      endFilterDisplayValue: null,
      filterStartMenu: false,
      dateFilterDisplayValue: null,
      filterDateMenu: false,
      filterEndMenu: false,
    }
  },
  computed: {
    totals(){
      let count = 0;
      for (let i = 0; i < this.items.length; i++){
        count += this.totalsByClient(this.items[i].Client)
      }

      return count
    },
    totalsByRegion() {
      const totalRegionCounts = {};

      this.items.forEach((client) => {
        client.Regions.forEach((regionObj) => {
          const region = regionObj.Region;
          const count = regionObj.Count;

          totalRegionCounts[region.Id] = (totalRegionCounts[region.Id] || 0) + count;
        });
      });

      return {
        totalRegionCounts: totalRegionCounts,
      }
    },
    disableRefreshButton() {
      if (this.allowedFullAccessToPeriod === true) {
        return false
      }

      return this.isAllowedReload() || this.$v.$invalid
    },
    allowedFullAccessToPeriod() {
      const allowedUserIds = [1,10,11,30,44,45,67,225,227,262,931,1009,1027,1554,1722,2158,2196,17480,18260];

      if (allowedUserIds.includes(this.$store.getters.appLogin.id)) {
        return true;
      }
      return false;
    }
  },
  validations: {
    filters: {
      start: {
        required
      },
      end: {
        required
      }
    }
  },
  methods: {
    toggleClients(){
      if(this.filters.selectedClients.length === 0){
        for (const item of this.items) {
          this.filters.selectedClients.push(item.Client.id)
        }
      }
      else {
        this.filters.selectedClients = []
      }
    },
    toggleRegion(regionId) {
      const index = this.filters.selectedRegions.findIndex(id => id === regionId);
      if (index !== -1) {
        this.filters.selectedRegions.splice(index, 1);
      } else {
        this.filters.selectedRegions.push(regionId);
      }
    },
    toggleClient(clientId) {
      const index = this.filters.selectedClients.findIndex(id => id === clientId);
      if (index !== -1) {
        this.filters.selectedClients.splice(index, 1);
      } else {
        this.filters.selectedClients.push(clientId);
      }
    },
    isAllowedReload() {
      const startDate = this.filters.start;
      const endDate = this.filters.end;

      if (startDate && endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);

        const dayDifference = (end - start) / (1000 * 60 * 60 * 24);

        if (dayDifference > DateLimitForFilters) {
          return true;
        }
      }
    },
    totalsByClient(client) {
      let count = null;

      _.each(this.items, item => {
        if (item.Client === client) {
          for (let i = 0; i < item.Regions.length; i++) {
            if (item.Regions[i].Count !== null) {
              count += item.Regions[i].Count;
            }
          }
        }
      });

      return count;
    },
    updateItems() {
      this.$emit('updated', this.filters)
    },
    onRefreshClicked() {
      this.updateItems()
    },
    onFilterStartChanged() {
      if (this.filters.start) {
        this.startFilterDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }

      this.filterStartMenu = false
    },
    onFilterEndChanged() {
      if (this.filters.end) {
        this.endFilterDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }

      this.filterEndMenu = false
    },
    onFilterDateChanged() {
      if (this.filters.date) {
        this.dateFilterDisplayValue = Moment(this.filters.date, 'YYYY-MM').format('MM.YYYY')
      }

      this.filterDateMenu = false
    },

    onPrintClicked() {
      window.print()
    }
  },
  created() {
    this.filters.start = Moment().subtract(1, 'days').format('YYYY-MM-DD')
    this.filters.end = Moment().subtract(1, 'days').format('YYYY-MM-DD')
    this.updateItems()
    this.filters.selectedClients.push(this.$store.getters.appActiveClient.id)
    this.filters.selectedRegions.push(this.$store.getters.appRegions[0].id)

    this.startFilterDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
    this.endFilterDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')
  }
}
</script>

<style scoped>
.filter-header {
  padding: 2px;
  border-radius: 5px;
  font-size: 12px;
  cursor: pointer;
}

.filter-header:hover{
  background-color: #dfe7ed;
}
@media print {
  .table-container {
    overflow: visible !important;
    width: 100%;
  }
}

.table-scroll thead th {
  padding: 0 5px 0 5px;
}

th {
  text-align: center;
  border-right: 2px solid black;
  border-bottom: 2px solid black !important;
}

tr th:first-child {
  border-left: 2px solid black;
}

tr:nth-child(2) th:first-child {
  border-left: 0;
}

tr:first-child th {
  border-top: 2px solid black;
}

td {
  text-align: center;
  border-right: 1px solid #253d6d;
  border-bottom: 1px solid #253d6d;
}

td:first-child {
  text-align: left;
  border-left: 1px solid #253d6d;
}

@media print {
  td, th {
    padding: 0 5px !important;
    margin: 0 !important;
  }

  table {
    page-break-inside: auto
  }

  tr {
    page-break-inside: avoid;
    page-break-after: auto
  }
}
</style>
